import { render, staticRenderFns } from "./DigitalMarketingCoordinator.vue?vue&type=template&id=0e1910a2&scoped=true&"
import script from "./DigitalMarketingCoordinator.vue?vue&type=script&lang=js&"
export * from "./DigitalMarketingCoordinator.vue?vue&type=script&lang=js&"
import style0 from "./DigitalMarketingCoordinator.vue?vue&type=style&index=0&id=0e1910a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1910a2",
  null
  
)

export default component.exports